// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ui/Leaderboard.css */
.unified-leaderboard {
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}

.ul-title {
  font-size: 13px;
  color: #fbbf24;
  text-align: center;
  margin-bottom: 12px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.ul-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ul-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  color: #f8fafc;
}

.ul-item.is-me {
  background: rgba(251, 191, 36, 0.15);
  border-left: 3px solid #fbbf24;
  color: #fbbf24;
}

.ul-rank {
  font-weight: 900;
  width: 25px;
  opacity: 0.7;
}

.ul-name {
  flex: 1 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
}

.ul-score {
  font-weight: bold;
  color: #2ecc71;
}

.is-me .ul-score {
  color: #fbbf24;
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/ui/Leaderboard.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ui/Leaderboard.css */\n.unified-leaderboard {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  padding: 12px;\n  margin: 10px 0;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-sizing: border-box;\n}\n\n.ul-title {\n  font-size: 13px;\n  color: #fbbf24;\n  text-align: center;\n  margin-bottom: 12px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.ul-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ul-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 8px;\n  font-size: 14px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  color: #f8fafc;\n}\n\n.ul-item.is-me {\n  background: rgba(251, 191, 36, 0.15);\n  border-left: 3px solid #fbbf24;\n  color: #fbbf24;\n}\n\n.ul-rank {\n  font-weight: 900;\n  width: 25px;\n  opacity: 0.7;\n}\n\n.ul-name {\n  flex: 1;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0 10px;\n}\n\n.ul-score {\n  font-weight: bold;\n  color: #2ecc71;\n}\n\n.is-me .ul-score {\n  color: #fbbf24;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
